/**
 * Created by augustocorvalan on 3/26/14.
 * UMD'ed by augustocorvalan on 4/16/14.
 */
'use strict';

var $ = require('dibs-jquery-shim');
var User = require('../global/models/User');
var price = require('../global/mixins/commonjs/price');
var currencies = require('dibs-currency-helpers/constants').currencies || {};
var DEFAULT_CURRENCY = currencies.DEFAULT_USD;
var findNamespaceValue = require('find-namespace-value');
var ContextProvider = require('../global/reactHelpers/ContextProvider');
var UserStore = require('../global/stores/UserStore.es');
var currencyActions = require('../global/actions/currencyActions.es');

/**
 * Initializes CurrencyLoader class
 * @param options
 * @param $el {obj} jQuery object of DOM region to be affected
 * @param userLoadOptions {obj} options to be passed in to dibs.user.load
 * @constructor
 */
function CurrencyLoader(options) {
    var self = this;
    var _defaults = {
        $el: null,
        userLoadOptions: {
            full: false,
            force: false
        }
    };

    this.options = $.extend(_defaults, options);
    if (this.options.$el) {
        this.$el = this.options.$el;
    }
    if (this.$el && !User.loggedIn()) {
        //only need to listen for this if the user is logged out
        // and there's an $el to update...
        User.getCurrentUser().on('login:change', function () {
            self.onLoginPriceUpdate();
        });
    }
}

module.exports = CurrencyLoader;

$.extend(CurrencyLoader.prototype, {

    /**
     * event handler for user login/register success via the authModal,
     * resets the currency on prices
     * @param {object} userData
     * @param {object} userData.profile
     * @param {string} userData.profile.currency
     */
    onLoginPriceUpdate : function (userData) {
        this.updatePrices(true, findNamespaceValue('profile.currency', userData, DEFAULT_CURRENCY));
    },

    /**
     * calls currencyActions.loadCurrencyForUser to grab the preferred currency and passes it along to the
     * price mixin to show the prices
     */
    loadLocalizedPrices: function () {
        var self = this;
        var deferred = $.Deferred();

        ContextProvider.getContext().then(function (context) {
            context
                .executeAction(currencyActions.loadCurrencyForUser)
                .then(function () {
                    var currency = context.getStore(UserStore).getCurrency();
                    self.updatePrices(true, currency);
                    self.showLabels();
                    deferred.resolve(currency);
                });
        });

        return deferred.promise();
    }
}, price);



//////////////////
// WEBPACK FOOTER
// ./assets/js/user/CurrencyLocalization.js
// module id = 1118
// module chunks = 64